import { LineSpace } from '@/components/ProductComponents';
import First from './First';
import Second from './Second';
import Third from './Third';
import Fourth from './Fourth';
import Fifth from './Fifth';

export default function MultiSellPointsModule() {
    return (
        <div className="multiSellPointsModule">
            <First />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Second />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Third />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Fourth cssStyle={{ height: '900px', textIconStyle: { wrapperBackColor: '#f6f6f8' } }} />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Fifth />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <First
                cssStyle={{
                    backColor: '#000',
                    guideStyle: { color: '#7cabff' },
                    titleStyle: { color: '#ffffff' },
                    descStyle: { color: '#999999' },
                    textIconStyle: { titleColor: '#ffffff', desColor: '#919191' },
                }}
            />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Second
                cssStyle={{
                    backColor: '#000',
                    guideStyle: { color: '#7cabff' },
                    titleStyle: { color: '#ffffff' },
                    descStyle: { color: '#999999' },
                    textIconStyle: { titleColor: '#ffffff', desColor: '#919191' },
                }}
            />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Third
                cssStyle={{
                    backColor: '#000',
                    guideStyle: { color: '#7cabff' },
                    titleStyle: { color: '#ffffff' },
                    descStyle: { color: '#999999' },
                    textIconStyle: {
                        titleColor: '#ffffff',
                        desColor: '#919191',
                        wrapperBackColor: '#181818',
                    },
                }}
            />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
            <Fourth
                cssStyle={{
                    backColor: '#000',
                    height: '900px',
                    guideStyle: { color: '#7cabff' },
                    titleStyle: { color: '#ffffff' },
                    descStyle: { color: '#999999' },
                    textIconStyle: {
                        titleColor: '#ffffff',
                        desColor: '#919191',
                        wrapperBackColor: '#181818',
                    },
                }}
            />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" />
            <Fifth
                cssStyle={{
                    backColor: '#000',
                    title1Style: { color: '#ffffff' },
                    title2Style: { color: '#919191' },
                    textIconStyle: { backcolor: '#919191', color: '#919191' },
                }}
            />
            <LineSpace height={250} background="#c1c1c1" border="1px solid #979797" opacity={0.49} />
        </div>
    );
}
